module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cmt5p"))).then(() => parcelRequire('1iHdE'));